import { z } from 'zod'

// Supported language codes (ISO 639-1)
export const SUPPORTED_LANGUAGE_CODES = [
  'de',
  'el',
  'en',
  'es',
  'fr',
  'hu',
  'it',
  'nl',
  'sv',
  'tr',
] as const

export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGE_CODES)[number]

export const supportedLanguageSchema = z.enum(SUPPORTED_LANGUAGE_CODES)
